import { ReportTableTab } from '../TrainingReports.types';
import {
	ReportTabDefinition,
	RowStatus,
	RowStatusPresentation
} from './TrainingTable.types';

export const DEFAULT_TABLE_TAB = ReportTableTab.Users;

export const REPORT_TABS: ReportTabDefinition[] = [
	{
		key: ReportTableTab.Users,
		label: 'learning.report.filterTab.users.label',
		icon: 'users',
		searchPlaceholder: 'learning.report.filterTab.users.placeHolder'
	},
	{
		key: ReportTableTab.Assignments,
		label: 'learning.report.filterTab.assignments.label',
		icon: 'assignmentsFilterIcon',
		searchPlaceholder: 'learning.report.filterTab.assignments.placeHolder'
	},
	{
		key: ReportTableTab.Courses,
		label: 'learning.report.filterTab.courses.label',
		icon: 'indiCoursesOutline',
		searchPlaceholder: 'learning.report.filterTab.courses.placeHolder'
	}
];

export const ROW_STATUS_PRESENTATION: Record<
	RowStatus,
	RowStatusPresentation
> = {
	[RowStatus.Complete]: { label: 'learning.report.filterDefinitions.status.options.complete', tone: 'primary' },
	[RowStatus.Incomplete]: { label: 'learning.report.filterDefinitions.status.options.incomplete', tone: 'default' },
	[RowStatus.Overdue]: { label: 'learning.report.filterDefinitions.status.options.overdue', tone: 'warning' },
	[RowStatus.NotStarted]: { label: 'learning.report.filterDefinitions.status.options.notStarted', tone: 'default' }
};

export const COURSE_STATUS_PRESENTATION: Record<
	RowStatus,
	RowStatusPresentation
> = {
	[RowStatus.Complete]: { label: 'learning.report.filterDefinitions.status.options.complete', tone: 'primary' },
	[RowStatus.Incomplete]: { label: 'learning.report.filterDefinitions.status.options.inprogress', tone: 'default' },
	[RowStatus.Overdue]: { label: 'learning.report.filterDefinitions.status.options.overdue', tone: 'warning' },
	[RowStatus.NotStarted]: { label: 'learning.report.filterDefinitions.status.options.notStarted', tone: 'default' }
};

/** Same statuses as the table, relabelled for assignments. Tones unchanged. */
export const ASSIGNMENT_STATUS_PRESENTATION: Record<
	RowStatus,
	RowStatusPresentation
> = {
	...ROW_STATUS_PRESENTATION,
	[RowStatus.Complete]: { label: 'learning.report.charts.statusFilter.completed', tone: 'primary' },
	[RowStatus.Incomplete]: { label: 'learning.report.filterDefinitions.status.options.inprogress', tone: 'default' }
};

/** The two values the Courses tab's "Required" column reports. */
export const COURSE_TYPE = {
	Required: 'Required',
	Optional: 'Optional'
} as const;

export const COURSE_DETAILS_DRAWER_WIDTH = 640;
/** Participant rows a property section shows before "View all". */
export const COURSE_USERS_PREVIEW_COUNT = 10;
export const COURSE_USER_COLUMNS = ['learning.report.tableHeaders.user', 'learning.report.tableHeaders.status', 'learning.report.tableHeaders.due'];

export const ASSIGNMENT_DETAILS_DRAWER_WIDTH = 640;
/** Participant rows a course table shows before "View all". */
export const ASSIGNMENT_USERS_PREVIEW_COUNT = 10;
export const ASSIGNMENT_USER_COLUMNS = COURSE_USER_COLUMNS

export const USER_DETAILS_DRAWER_WIDTH = 640;
export const USER_DETAILS_DATE_FORMAT = 'M/D/YY';
export const USER_DETAILS_COURSE_COLUMNS = ['learning.report.tableHeaders.course', 'learning.report.tableHeaders.status', 'learning.report.tableHeaders.due'];

/** Widths below which each tab's table scrolls sideways rather than clipping. */
export const TABLE_MIN_WIDTH: Record<ReportTableTab, number> = {
	[ReportTableTab.Users]: 1100,
	[ReportTableTab.Assignments]: 1260,
	[ReportTableTab.Courses]: 1240
};

export const EXPAND_COLUMN_WIDTH = 48;

export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const PAGINATION_BOUNDARY_COUNT = 2;
export const PAGINATION_SIBLING_COUNT = 1;

export const DETAILS_LABEL = 'learning.report.detailBtn';
export const TABLE_EMPTY_TEXT = 'learning.report.filterTab.errors.noMatchFilter';

export const REPORT_SEARCH_DEBOUNCE_MS = 300;
export const REPORT_DETAIL_PAGE_SIZE = 1000;
export const UNKNOWN_VALUE = '-';
